import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useMaintenanceMode() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchStatus = async () => {
    try {
      const { data } = await supabase
        .from("settings")
        .select("settings")
        .eq("category", "maintenance")
        .maybeSingle();

      if (data?.settings) {
        const s = typeof data.settings === "string" ? JSON.parse(data.settings) : data.settings;
        setIsMaintenanceMode(!!s.enabled);
        setMaintenanceMessage(s.message || "");
      }
    } catch {
      // Ignore errors - default to not in maintenance
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const toggleMaintenanceMode = async (enabled: boolean, message?: string) => {
    try {
      const settings = { enabled, message: message || "" };

      // Check if row exists
      const { data: existing } = await supabase
        .from("settings")
        .select("id")
        .eq("category", "maintenance")
        .maybeSingle();

      if (existing) {
        await supabase
          .from("settings")
          .update({ settings: settings as any })
          .eq("id", existing.id);
      } else {
        // Need user_id for insert - get from auth
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) throw new Error("No authenticated user");
        
        await supabase.from("settings").insert({
          user_id: user.id,
          category: "maintenance",
          settings: settings as any,
        });
      }

      setIsMaintenanceMode(enabled);
      setMaintenanceMessage(message || "");
      return true;
    } catch (e) {
      console.error("Error toggling maintenance mode:", e);
      return false;
    }
  };

  return { isMaintenanceMode, maintenanceMessage, loading, toggleMaintenanceMode, refetch: fetchStatus };
}
